import React, { useEffect, useState } from "react";
import { MenuPane, MenuPaneHeader } from "../components/menu";
import { APIGroups } from "kpm-backend-interface";
import { fetchApi, postApi, useDataFecther, prefixHost } from "./utils";
import {
  AuthError,
  EmptyPlaceholder,
  ErrorMessage,
  LoadingPlaceholder,
} from "../components/common";
import { i18n } from "../i18n/i18n";
import "./groups.scss";
import { IconSettings } from "../components/icons";

export async function loaderStudies({ request }: any = {}): Promise<APIGroups> {
  const res = await fetchApi("/api/groups", {
    signal: request?.signal,
  });
  const json = await res.json();
  if (res.ok) {
    return json;
  } else {
    if (res.status === 401) {
      throw new AuthError(json.message);
    }
    throw new Error(json.message);
  }
}

export function useMutateGroups(res: APIGroups | undefined): {
  groups: APIGroups["groups"] | undefined;
} {
  const [groups, setGroups] = useState<APIGroups["groups"]>();

  // Update state on res change (loaded/updated)
  useEffect(() => {
    if (res) {
      setGroups(res.groups);
    }
  }, [res]);

  return {
    groups,
  };
}

export function Groups() {
  const { res, loading, error } = useDataFecther<APIGroups>(loaderStudies);
  const { groups } = useMutateGroups(res);

  const isEmpty = !loading && !error && groups?.length === 0;

  return (
    <MenuPane className="kpm-groups" error={error}>
      <MenuPaneHeader title={i18n("My Groups")}>
        <a
          title={i18n("Search for interesting groups to follow")}
          href={prefixHost(
            "www",
            "/search/?entityFilter=social-group&filterLabel=Groups"
          )}
        >
          {i18n("Find groups")}
        </a>
        <IconSettings
          href={prefixHost("www", "/social/home/settings/groups")}
        />
      </MenuPaneHeader>
      <div className="kpm-warning-banner" role="status" aria-live="polite">
        <span>
          {i18n("groups_banner_prefix")} {" "}
          <a
            href="https://intra.kth.se/utbildning/e-larande/e-larande-nyheter/gruppwebben-och-social-stanger-hosten-2026-1.1493255"
            target="_blank"
            rel="noopener noreferrer"
          >
            {i18n("groups_banner_link_text_1")}
          </a>
          {i18n("groups_banner_text_end")} {" "}
          <a
            href="https://intra.kth.se/utbildning/nyheter/gruppwebben-som-samarbetsyta-stangs-hosten-2026-1.1462814"
            target="_blank"
            rel="noopener noreferrer"
          >
            {i18n("groups_banner_link_text_2")}
          </a>
        </span>
      </div>
      {loading && <LoadingPlaceholder />}
      {error && <ErrorMessage error={error} />}
      {isEmpty && (
        <EmptyPlaceholder>
          {i18n("You don't belong to any groups.")}
        </EmptyPlaceholder>
      )}
      {!isEmpty && (
        <ul>
          {groups?.map((group) => (
            <li className="kpm-groups-item" key={`kpm-group-${group.slug}`}>
              <a href={group.url}>{group.name}</a>
            </li>
          ))}
        </ul>
      )}
    </MenuPane>
  );
}
